// Static products data
export const products = [
  {
    _id: '1',
    id: 1,
    name: 'Cantilever Shade Designs',
    description: 'Cantilever shade structures offer a modern, unobstructed solution for protecting vehicles and outdoor spaces. Designed with a single-sided support system, these shades eliminate the need for multiple columns, maximizing usable space and ensuring easy vehicle movement. Built with high-quality steel frames and durable UV-resistant fabric, cantilever designs provide long-lasting protection against sun, rain, and harsh weather conditions. Ideal for residential parking, commercial spaces, and car yards, they combine strength, functionality, and sleek architectural appeal.',
    price: 'Custom Quote',
    category: 'Shade Structures',
    image: '/images/cantilever-shade.jpg',
    specs: [
      'Single-sided support system',
      'Maximized usable space',
      'High-quality steel frames',
      'UV-resistant fabric',
      'Weather-resistant',
      'Modern design'
    ],
    createdAt: new Date('2025-01-15')
  },
  {
    _id: '2',
    id: 2,
    name: 'Curved Shade Designs',
    description: 'Curved shade structures bring a stylish and contemporary look while delivering superior coverage and durability. Their aerodynamic shape enhances wind resistance and allows efficient water runoff during rainy conditions. Crafted using premium materials, these shades offer reliable protection from UV rays and environmental elements, helping preserve vehicles and outdoor assets. Perfect for homes, offices, and public spaces, curved designs blend aesthetics with performance for a visually appealing and practical shading solution.',
    price: 'Custom Quote',
    category: 'Shade Structures',
    image: '/images/curved-shade.jpg',
    specs: [
      'Aerodynamic design',
      'Superior wind resistance',
      'Efficient water runoff',
      'Premium materials',
      'UV protection',
      'Contemporary aesthetics'
    ],
    createdAt: new Date('2025-01-10')
  },
  {
    _id: '3',
    id: 3,
    name: 'Privacy Screen Fences',
    description: 'Privacy screen fences provide an effective and elegant way to enhance security while maintaining a clean, modern appearance. Designed to block unwanted views and reduce noise, these screens are ideal for residential compounds, commercial properties, and outdoor spaces. Made from durable, weather-resistant materials, they ensure long-term performance with minimal maintenance. Whether for boundary definition or added privacy, these fences deliver both functionality and a refined finish to any property.',
    price: 'Custom Quote',
    category: 'Privacy Solutions',
    image: '/images/privacy-fence.jpg',
    specs: [
      'View blocking',
      'Noise reduction',
      'Weather-resistant',
      'Minimal maintenance',
      'Modern finish',
      'Security enhancement'
    ],
    createdAt: new Date('2025-01-05')
  }
];

export default products;
